import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { BaseApiService } from '@carm/_core/baseapi.service';
import { Observable } from 'rxjs';
import { UserService } from '@carm/_core/access-control-mgt/facade/user.service';
import { IBaseResponse } from '@carm/_utils/models';
import {
  GoodsTemplateListItemModel,
  IGoodTemplatesListResponse,
  IVendorTemplatesListResponse,
  VendorTemplateListItemModel,
} from '../models/api';
import { LoaderSpinnerTypes } from '@carm/_core';

@Injectable()
export class TemplatesService extends BaseApiService {

  get serviceBaseUrl(): string {
    return `${this.endPointBP}/cad/templates`;
  }

  constructor(protected injector: Injector, public userService: UserService) {
    super(injector);
  }

  // Creates a new goods template
  createGoodsTemplate(
    templateData: GoodsTemplateListItemModel
  ): Observable<IBaseResponse> {
    const endpoint = `${this.serviceBaseUrl}/good-template`;
    return this.httpAuthPost<IBaseResponse>(endpoint, templateData);
  }

  // Rreturns the details of the particular goods template
  getGoodsTemplateDetails(id: string): Observable<GoodsTemplateListItemModel> {
    const endpoint = `${this.serviceBaseUrl}/good-template/${id}`;
    return this.httpAuthGet<GoodsTemplateListItemModel>(endpoint);
  }

  // Updates existing Goods template
  updateGoodsTemplate(
    templateData: GoodsTemplateListItemModel
  ): Observable<IBaseResponse> {
    const endpoint = `${this.serviceBaseUrl}/good-template/${templateData.template.id}`;
    return this.httpAuthPut<IBaseResponse>(endpoint, templateData);
  }

  deleteGoodsTemplate(id: string): Observable<IBaseResponse> {
    const endpoint = `${this.serviceBaseUrl}/good-template/${id}`;
    return this.httpAuthDelete<IBaseResponse>(endpoint);
  }

  getGoodsTemplatesList(loaderSpinnerType: LoaderSpinnerTypes): Observable<IGoodTemplatesListResponse> {
    const endpoint = `${this.serviceBaseUrl}/good-template-list`;

    const params = new HttpParams()
    .set('currentPage', '1')
    .set('pageSize', '500');  //hyrbris limit actually 100?

    return this.httpAuthGet<IGoodTemplatesListResponse>(endpoint, params, loaderSpinnerType);
  }

  createVendorTemplate(
    templateData: VendorTemplateListItemModel
  ): Observable<IBaseResponse> {
    const endpoint = `${this.serviceBaseUrl}/vendor-template`;
    return this.httpAuthPost<IBaseResponse>(endpoint, templateData).pipe(
      data => {
        return data;
      }
    );
  }

  getVendorTemplateDetails(
    id: string
  ): Observable<VendorTemplateListItemModel> {
    const endpoint = `${this.serviceBaseUrl}/vendor-template/${id}`;
    return this.httpAuthGet<VendorTemplateListItemModel>(endpoint);
  }

  updateVendorTemplate(
    templateData: VendorTemplateListItemModel
  ): Observable<IBaseResponse> {
    const endpoint = `${this.serviceBaseUrl}/vendor-template/${templateData.template.id}`;
    return this.httpAuthPut<IBaseResponse>(endpoint, templateData).pipe(
      data => {
        return data;
      }
    );
  }

  deleteVendorTemplate(id: string): Observable<IBaseResponse> {
    const params = new HttpParams().set('templateId', id);
    const endpoint = `${this.serviceBaseUrl}/vendor-template/${id}`;
    return this.httpAuthDelete<IBaseResponse>(endpoint, params);
  }

  getVendorsTemplatesList(loaderSpinnerType: LoaderSpinnerTypes): Observable<IVendorTemplatesListResponse> {
    const endpoint = `${this.serviceBaseUrl}/vendor-template-list`;
    const params = new HttpParams()
      .set('currentPage', '1')
      .set('pageSize', '500'); //hyrbris limit actually 100?

    return this.httpAuthGet<IVendorTemplatesListResponse>(endpoint, params, loaderSpinnerType);
  }
}
